import Rating from "../../common/Rating";
import IconButton from "../../common/IconButton";
import { Button } from "react-bootstrap";
// Hooks
import { useNavigate, Link } from "react-router-dom";
import { useState, useContext, useEffect } from "react";
import { usePermisions } from "../../../hooks/usePermisions";

// variables de entorno
import { URL_IMAGE_GEOMEDELLIN } from "../../../environment";

// contexto global geomedellin
import contextGeomedellin from "../../../context/contextGeomedellin";

// services (http request)
import cambiarEstado from "../../../services/cambiarEstado";

// componentes
import AdminGeoServicios from "../admin/forms/AdminGeoServicios";
import AdminAplicacion from "../admin/forms/AdminAplicacion";
import AdminDocumento from "../admin/forms/AdminDocumento";
import AdminNoticia from "../admin/forms/AdminNoticia";
import { AdminDatoAbierto } from "../admin/forms/AdminDatoAbierto";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
// services http request
import registrarEstadistica from "../../../services/estadistica";
import guardarUbicacion from "../../../services/guardarUbicacion";
import AdminGrupos from "../admin/forms/AdminGrupos";

import { convertirFechaISOaDDMMAAAA } from "../../../helpers/utils";

export default function Card({
  component,
  data = [],
  filtros,
  reRender,
  buscar,
  handleLoad,
}) {
  // console.log('Card data', data)
  const navigate = useNavigate();

  const { componentes, refDivCard, refDivCardOpenData } =
    useContext(contextGeomedellin);

  // const [buscadorGlobal, setBuscadorGlobal] = useState(location?.state?.data);

  const [objectEditar, setObjectEditar] = useState(null);
  const MySwal = withReactContent(Swal);
  // Estado modal
  const [show, setShow] = useState(false);
  // Cerrar modal
  const handleClose = () => {
    setShow(false);
  };
  // Abrir modal
  const handleShow = () => setShow(true);

  async function funcionEliminar(route, data, routeBuscador) {
    handleLoad(true);
    const [resp1, resp2] = await Promise.all([
      cambiarEstado(route, data),
      cambiarEstado(routeBuscador, data),
    ]);
    if (route.includes("noticias")) {
      if (resp1.eliminado) {
        MySwal.fire({
          title: "Se ha completado el proceso",
          text: "El proceso se ha ejecutado de forma exitosa",
          confirmButtonText: "Aceptar",
          customClass: {
            title: "sweet-alert-title",
            htmlContainer: "sweet-alert-container",
            confirmButton: "sweet-alert-confirm-button",
          },
        });
      } else {
        MySwal.fire({
          html: "<strong>Esta noticia ya tiene un archivo descargado y/o posee calificación</strong>, por lo que no se eliminará. En su lugar, <strong>será deshabilitado.</strong>",
          confirmButtonText: "Aceptar",
          customClass: {
            htmlContainer: "sweet-alert-container",
            confirmButton: "sweet-alert-confirm-button",
          },
        });
      }
    } else {
      MySwal.fire({
        title: "Se ha completado el proceso",
        text: "El proceso se ha ejecutado de forma exitosa",
        confirmButtonText: "Aceptar",
        customClass: {
          title: "sweet-alert-title",
          htmlContainer: "sweet-alert-container",
          confirmButton: "sweet-alert-confirm-button",
        },
      });
    }

    handleLoad(false);
    await buscar();
  }

  const redireccionCard = (vinculo) => {
    if (vinculo) {
      window.open(vinculo, "_blank");
    } else {
      return false;
    }
  };

  const eliminar = async (route, data = {}, routeBuscador) => {
    try {
      MySwal.fire({
        title: "Señor usuario",
        text: "¿Está seguro que desea continuar con el proceso?",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        customClass: {
          title: "sweet-alert-title-seguro",
          htmlContainer: "sweet-alert-container-seguro",
          confirmButton: "sweet-alert-confirm-button-seguro",
          cancelButton: "sweet-alert-cancel-button-seguro",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          funcionEliminar(route, data, routeBuscador);
        }
      });
      //   if (window.confirm("Desea eliminar?")) {
      //     Promise.all([
      //       await cambiarEstado(route, data),
      //       await cambiarEstado(routeBuscador, data),
      //     ]);

      //     alert("Se elimino correctamente");
      //     await buscar();
      //   } else {
      //     alert("cancelo la eliminacion");
      //   }
    } catch (error) {
      console.log(error);
    }
  };

  // useEffect(() => {
  //   if (component === 0) {
  //     if (!buscadorGlobal) {
  //       navigate("/");
  //     }
  //   }
  // }, []);

  async function buscar2() {
    await buscar();
  }

  const { permissions, infoUser } = usePermisions(component);

  if (component === 5) {
    return (
      <div className="tamano-card-result" ref={refDivCard}>
        {data.length > 0 ? (
          data.map((aplicacion, index) => {
            return (
              <div
                key={aplicacion.id_aplicacion}
                className="card-content color-fondo-card top-descricpion-result-busqueda hover-tajetas-aplicaciones"
              >
                <div className="conyten-img-card">
                  <button
                    className={`redirect-cards`}
                    onClick={() => {
                      redireccionCard(aplicacion.vinculo);
                      guardarUbicacion("5", "2", aplicacion.id_aplicacion);
                    }}
                  >
                    <img
                      className="app-img"
                      src={`${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Aplicaciones/${aplicacion.id_aplicacion}/${aplicacion.imagen}`}
                      alt={aplicacion.imagen}
                    />
                  </button>
                  {aplicacion.permite_edicion || permissions.superAdmin ? (
                    <div className="content-opciones-card">
                      {aplicacion.permite_edicion || permissions.superAdmin ? (
                        <div
                          className="editar"
                          title="Editar"
                          onClick={() => {
                            handleShow();
                            setObjectEditar(aplicacion);
                          }}
                        >
                          <IconButton className="icon-editar" />
                        </div>
                      ) : (
                        ""
                      )}
                      {permissions.superAdmin && aplicacion.activo ? (
                        <div
                          className="eliminar"
                          onClick={() => {
                            eliminar(
                              `geomed/aplicaciones/${aplicacion.id_aplicacion}`,
                              { estado: false },
                              `geomed/buscador/${aplicacion.id_aplicacion}/${component}`
                            );
                          }}
                          title="Eliminar"
                        >
                          <IconButton className="icon-eliminar" />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="padding-tarjetas-app">
                  <div className="flex-tarjetas-app">
                    {aplicacion?.calificable ? (
                      <Rating
                        route={"geomed/calificacion"}
                        idRegistro={aplicacion.id_aplicacion}
                        reRender={reRender}
                        numCalificacion={aplicacion.num_calificacion}
                        key={aplicacion.id_aplicacion}
                        origen={"aplicaciones"}
                      />
                    ) : (
                      ""
                    )}
                    {aplicacion?.calificable ? (
                      <span>{`${aplicacion?.porcentaje}%`}</span>
                    ) : (
                      ""
                    )}
                    <div>
                      <p className="lbl-tarjetas-app-rating">
                        {
                          filtros.resultTiposApp.find(
                            (tipo) => tipo.id_tipo === aplicacion.fk_id_tipo
                          )?.nombre
                        }
                      </p>
                    </div>
                  </div>
                  <div className="mt-2">
                    <label className="lbl-tarjetas-app">
                      {aplicacion.nombre}
                    </label>
                    <label
                      className="lbl-descripcion-app mt-2"
                      title={aplicacion.descripcion}
                    >
                      {aplicacion.descripcion}
                    </label>
                  </div>
                </div>
                <div className="flex-direction-hr">
                  <hr className="hr-tarjetas-card" />
                </div>
              </div>
            );
          })
        ) : (
          <>
            <div className="flex-msg_noResults">
              <h2>No se han encontrado resultados para tu búsqueda.</h2>
            </div>
          </>
        )}
        <AdminAplicacion
          caractFiltro={filtros}
          idComponente={component}
          show={show}
          onHide={() => handleClose()}
          tituloModal={"Editar Aplicación"}
          accion={"Editar"}
          objectEditarApp={objectEditar}
          buscar={buscar}
        />
      </div>
    );
  } else if (component === 1) {
    return (
      <>
        <div className="tamano-card-result" ref={refDivCard}>
          {data.length > 0 ? (
            data?.map((geoservicio) => {
              return (
                <>
                  <div
                    key={geoservicio.id_geoservicio}
                    className="card-content top-descricpion-result-busqueda hover-tajetas-geoservicios"
                  >
                    <div className="conyten-img-card">
                      <button
                        className={`redirect-cards`}
                        onClick={async () => {
                          await guardarUbicacion(
                            component,
                            "2",
                            geoservicio.id_geoservicio
                          );
                          redireccionCard(geoservicio.vinculo);
                        }}
                        href={geoservicio.vinculo}
                        target={"_blank"}
                        rel="noreferrer"
                      >
                        <div>
                          <img
                            className="img-log-geoservico"
                            src={`${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Geoservicios/${geoservicio.id_geoservicio}//${geoservicio.imagen}`}
                            alt={geoservicio.imagen}
                          />
                        </div>
                      </button>
                      {geoservicio.permite_edicion || permissions.superAdmin ? (
                        <div className="content-opciones-card">
                          {geoservicio.permite_edicion ||
                          permissions.superAdmin ? (
                            <div
                              className="editar"
                              title="Editar"
                              onClick={() => {
                                handleShow();
                                setObjectEditar(geoservicio);
                              }}
                            >
                              <IconButton className="icon-editar" />
                            </div>
                          ) : (
                            ""
                          )}
                          {permissions.superAdmin && geoservicio.activo ? (
                            <div
                              className="eliminar"
                              onClick={() => {
                                eliminar(
                                  `geoservicios/${geoservicio.id_geoservicio}`,
                                  { estado: false },
                                  `geomed/buscador/${geoservicio.id_geoservicio}/${component}`
                                );
                              }}
                              title="Eliminar"
                            >
                              <IconButton className="icon-eliminar" />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="padding-tarjetas">
                      <div className="flex-tarjetas-app">
                        {geoservicio?.calificable ? (
                          <Rating
                            route={"geoservicios/calificacion"}
                            idRegistro={geoservicio.id_geoservicio}
                            reRender={reRender}
                            numCalificacion={geoservicio.num_calificacion}
                            key={geoservicio.id_geoservicio}
                            origen={"geoservicios"}
                          />
                        ) : (
                          ""
                        )}
                        {geoservicio?.calificable ? (
                          <span>{`${geoservicio?.porcentaje}%`}</span>
                        ) : (
                          ""
                        )}

                        <div>
                          <p className="lbl-tarjetas-app-rating">
                            {
                              filtros.resultTiposGeo.find(
                                (tipo) =>
                                  tipo.id_tipo === geoservicio.fk_id_tipo
                              )?.nombre
                            }
                          </p>
                        </div>
                      </div>
                      <div className="mt-1">
                        <label className="lbl-tarjetas-app">
                          {geoservicio?.nombre}
                        </label>
                        <label
                          className="lbl-descripcion-app mt-2"
                          title={geoservicio.descripcion}
                        >
                          {geoservicio?.descripcion}
                        </label>
                        <div>
                          <p className="lbl-tarjetas-app-rating">
                            {
                              filtros.resultTematicas.find(
                                (tematica) =>
                                  tematica.id_tematica ===
                                  geoservicio.fk_id_tematica
                              )?.nombre
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="flex-direction-hr">
                      <hr className="hr-tarjetas-card-geoservicio" />
                    </div>
                  </div>
                </>
              );
            })
          ) : (
            <>
              <div className="flex-msg_noResults">
                <h2>No se han encontrado resultados para tu búsqueda.</h2>
              </div>
            </>
          )}

          <AdminGeoServicios
            caractFiltro={filtros}
            idComponente={component}
            show={show}
            onHide={() => handleClose()}
            tituloModal={"Editar Geoservicio"}
            accion={"Editar"}
            objectEditarGeo={objectEditar}
            buscar={buscar}
          />
        </div>
      </>
    );
  } else if (component === 3) {
    return (
      <div className="tamano-card-result" ref={refDivCard}>
        {data.length > 0 ? (
          data.map((documento, index) => {
            return (
              <>
                <div
                  key={documento.id_documento}
                  className="card-content color-fondo-card top-descricpion-result-busqueda hover-tajetas-documentos"
                >
                  <div className="conyten-img-card tamano-content-doc">
                    <a
                      href={`${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Documentacion/${documento.id_documento}/${documento.archivo}`}
                      target="_blank"
                      rel={"noreferrer"}
                      download
                      onClick={async () =>
                        await guardarUbicacion(
                          component,
                          "2",
                          documento.id_documento
                        )
                      }
                    >
                      <img
                        className="img-pdf"
                        src={`${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Iconos/${
                          documento.archivo?.split(".")[1]
                        }.jpg`}
                        alt={documento.archivo}
                      />
                    </a>
                    {documento.permite_edicion || permissions.superAdmin ? (
                      <div className="content-opciones-card-doc">
                        {documento.permite_edicion || permissions.superAdmin ? (
                          <div
                            className="editar"
                            title="Editar"
                            onClick={() => {
                              handleShow();
                              setObjectEditar(documento);
                            }}
                          >
                            <IconButton className="icon-editar" />
                          </div>
                        ) : (
                          ""
                        )}
                        {permissions.superAdmin && documento.activo ? (
                          <div
                            className="eliminar"
                            title={"Eliminar"}
                            onClick={() => {
                              eliminar(
                                `documentacion/${documento.id_documento}`,
                                { estado: false },
                                `geomed/buscador/${documento.id_documento}/${component}`
                              );
                            }}
                          >
                            <IconButton className="icon-eliminar" />
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="padding-tarjetas-app">
                    <div className="flex-tarjetas-app">
                      {documento?.calificable ? (
                        <Rating
                          route={"documentacion/calificacion"}
                          idRegistro={documento.id_documento}
                          reRender={reRender}
                          numCalificacion={documento.num_calificacion}
                          key={documento.id_documento}
                          origen={"documentacion"}
                        />
                      ) : (
                        ""
                      )}
                      {documento?.calificable ? (
                        <span>{`${documento?.porcentaje}%`}</span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="mt-2">
                      <label
                        className="lbl-tarjetas-app"
                        title={documento.nombre}
                      >
                        {documento.nombre}
                      </label>
                      <div>
                        <p className="lbl-tarjetas-app-rating">
                          {
                            filtros.resultTematicas.find(
                              (tematica) =>
                                tematica.id_tematica ===
                                documento.fk_id_tematica
                            )?.nombre
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="flex-direction-hr">
                    <hr className="hr-tarjetas-card-doc" />
                  </div>
                </div>
              </>
            );
          })
        ) : (
          <>
            <div className="flex-msg_noResults">
              <h2>No se han encontrado resultados para tu búsqueda.</h2>
            </div>
          </>
        )}
        <AdminDocumento
          caractFiltro={filtros}
          idComponente={component}
          show={show}
          onHide={() => handleClose()}
          tituloModal={"Editar Documento"}
          accion={"Editar"}
          objectEditarDoc={objectEditar}
          buscar={buscar}
        />
      </div>
    );
  } else if (component === 2) {
    const urlDescargaFormatos = (formato, id_servicio) => {
      const urlNombreArchivo = formato.split("--")[3];

      if (!urlNombreArchivo) {
        return false;
      }

      if (
        id_servicio &&
        urlNombreArchivo.includes("https://www.medellin.gov.co/")
      ) {
        return urlNombreArchivo;
      }

      return `${URL_IMAGE_GEOMEDELLIN}/openDataExt/${urlNombreArchivo}`;
    };

    const mostrarImgDatoAbierto = (infoDatoAbierto) => {
      const { externo, imagen_ext, id_fuente_dato, imagen } = infoDatoAbierto;

      if (externo && imagen_ext) {
        return imagen_ext;
      }

      if (imagen?.includes("https://www.medellin.gov.co/")) {
        return imagen;
      }

      return `${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Datos_abiertos/${id_fuente_dato}/${imagen}`;
    };

    return (
      <div className="tamano-card-result-opendata" ref={refDivCardOpenData}>
        {data.length > 0 ? (
          data.map((datoAbierto) => {
            return (
              <div
                key={
                  datoAbierto.externo
                    ? datoAbierto.id_opendata_ext
                    : datoAbierto.id_fuente_dato
                }
                className="content-opedata-card mt-3"
              >
                <div className="container-opendata">
                  <div>
                    <img
                      className="icon-opendata"
                      src={mostrarImgDatoAbierto(datoAbierto)}
                      alt={
                        datoAbierto.externo
                          ? datoAbierto.imagen_ext
                          : datoAbierto.imagen
                      }
                    />
                  </div>
                  <div className="content-card-datos-abiertos">
                    <label
                      className="lbl-opendata"
                      title={
                        datoAbierto.externo
                          ? datoAbierto.nombre_ext
                            ? datoAbierto.nombre_ext
                            : "Dato sin título"
                          : datoAbierto.nombre
                      }
                    >
                      {datoAbierto.externo
                        ? datoAbierto.nombre_ext
                          ? datoAbierto.nombre_ext
                          : "Dato sin título"
                        : datoAbierto.nombre}
                    </label>
                    <div className="flex-tarjetas-app mt-2">
                      {datoAbierto?.calificacion ? (
                        <Rating
                          route={"opendata/calificacion"}
                          idRegistro={datoAbierto.id_fuente_dato}
                          reRender={reRender}
                          numCalificacion={datoAbierto.num_calificacion}
                          key={datoAbierto.id_aplicacion}
                          origen={"datosabiertos"}
                        />
                      ) : (
                        ""
                      )}
                      {datoAbierto?.calificacion ? (
                        <span>{`${datoAbierto?.porcentaje}%`}</span>
                      ) : (
                        ""
                      )}
                    </div>
                    <p
                      className="lbl-descripcion-card-opendata mt-3"
                      title={
                        datoAbierto.externo
                          ? datoAbierto.descripcion_ext
                            ? datoAbierto.descripcion_ext
                            : "N/A"
                          : datoAbierto.descripcion
                      }
                    >
                      {datoAbierto.externo
                        ? datoAbierto.descripcion_ext
                          ? datoAbierto.descripcion_ext
                          : "N/A"
                        : datoAbierto.descripcion}
                    </p>
                    {datoAbierto.permite_edicion || permissions.superAdmin ? (
                      !datoAbierto.externo ? (
                        <div className="content-opciones-card-open-data">
                          {datoAbierto.permite_edicion ||
                          permissions.superAdmin ? (
                            !datoAbierto.externo ? (
                              <div
                                className="editar"
                                title="Editar"
                                onClick={() => {
                                  handleShow();
                                  setObjectEditar(datoAbierto);
                                }}
                              >
                                <IconButton className="icon-editar" />
                              </div>
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}
                          {permissions.superAdmin &&
                          !datoAbierto.externo &&
                          datoAbierto.estado !== "0" ? (
                            <div
                              className="eliminar"
                              title="Eliminar"
                              onClick={() => {
                                eliminar(
                                  `opendata/${datoAbierto.id_fuente_dato}`,
                                  { estado: false },
                                  `geomed/buscador/${datoAbierto.id_fuente_dato}/${component}`
                                );
                              }}
                            >
                              <IconButton className="icon-eliminar" />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="content-opendata-card-formatos mt-1">
                  <p className="lbl-tarjetas-opdendata">
                    {datoAbierto.nombre_tematica}
                  </p>
                </div>
                <div className="flex-conoce-mas-opendata mt-2">
                  <div className="content-opendata-card-formatos ">
                    {datoAbierto.formatos
                      ?.split("/--/")
                      .map((formato = [], index = 0, arrayFormatos = []) => {
                        return (
                          <div key={`datoAbiertoFormatos${index}`}>
                            <a
                              href={urlDescargaFormatos(
                                formato,
                                datoAbierto.id_servicio
                              )}
                              rel={"noreferrer"}
                              download={formato.split("--")[3] ? true : false}
                              className="lbl-opendata-card-forma"
                              onClick={async () => {
                                if (formato.split("--")[3]) {
                                  // guardarUbicacion(
                                  //   component,
                                  //   "1",
                                  //   datoAbierto.id_fuente_dato
                                  // );
                                  await registrarEstadistica({
                                    idFuenteDato: datoAbierto.id_fuente_dato,
                                    tipoEstadistica: 1,
                                    idUsuario: infoUser,
                                    formato: formato.split("--")[1],
                                    origen: 1,
                                  });
                                  return;
                                }
                              }}
                            >
                              {formato.split("--")[2]}
                            </a>
                            {arrayFormatos.length - 1 === index ? (
                              ""
                            ) : (
                              <label className="lbl-barra-inclinada-formato-opendata">
                                /
                              </label>
                            )}
                          </div>
                        );
                      })}
                  </div>
                  {datoAbierto.metadato_privado ? (
                    <div className="flex-container_conoceMas">
                      <Link
                        id="linkInfoOpenData"
                        className="btn-conoce-mas-opendata"
                        to={`/datosAbiertos/${datoAbierto.id_fuente_dato}`}
                        onClick={async () => {
                          await registrarEstadistica({
                            idFuenteDato: datoAbierto.id_fuente_dato,
                            tipoEstadistica: 2,
                            idUsuario: infoUser,
                            origen: 1,
                          });
                        }}
                      >
                        CONOCE MÁS
                      </Link>
                    </div>
                  ) : null}
                </div>
              </div>
            );
          })
        ) : (
          <>
            <div className="flex-msg_noResults">
              <h2>No se han encontrado resultados para tu búsqueda.</h2>
            </div>
          </>
        )}

        <AdminDatoAbierto
          caractFiltro={filtros}
          idComponente={component}
          show={show}
          onHide={() => handleClose()}
          tituloModal={"Editar Dato abierto"}
          accion={"Editar"}
          objectEditarDatoAbierto={objectEditar}
          buscar={buscar}
        />
      </div>
    );
  }
  //NOTICIAS
  else if (component === 7) {
    return (
      <div className="tamano-card-result-noticias" ref={refDivCard}>
        {data.length > 0 ? (
          data.map((noticia, index) => {
            return (
              <div
                key={noticia.id_noticia}
                className="content-noticias-card mt-3"
              >
                <div className="container-opendata">
                  <div>
                    <button
                      className={`redirect-cards`}
                      onClick={() => {
                        redireccionCard(noticia.vinculo);
                        guardarUbicacion("7", "2", noticia.id_noticia);
                      }}
                    >
                      <img
                        className="icon-opendata"
                        src={`${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Noticias/${noticia.id_noticia}/${noticia.imagen}`}
                        alt={noticia.imagen}
                      />
                    </button>
                  </div>
                  <div className="content-card-datos-abiertos">
                    <label className="lbl-tarjetas-app">{noticia.nombre}</label>
                    <div className="flex-tarjetas-app mt-2">
                      {noticia?.calificable ? (
                        <Rating
                          route={"geomed/calificacion/noticia"}
                          idRegistro={noticia.id_noticia}
                          reRender={reRender}
                          numCalificacion={noticia.num_calificacion}
                          key={noticia.id_noticia}
                          origen={"noticias"}
                        />
                      ) : (
                        ""
                      )}
                      {noticia?.calificable ? (
                        <span>{`${noticia?.porcentaje}%`}</span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="mt-2">
                      <label
                        className="lbl-descripcion-app"
                        title={noticia.descripcion}
                      >
                        {noticia.descripcion}
                      </label>
                    </div>
                    {noticia.permite_edicion || permissions.superAdmin ? (
                      <div className="content-opciones-card-open-data">
                        <div
                          className="editar"
                          title="Editar"
                          onClick={() => {
                            handleShow();
                            setObjectEditar(noticia);
                          }}
                        >
                          <IconButton className="icon-editar" />
                        </div>
                        {noticia.permite_edicion &&
                        permissions.admin &&
                        noticia.activo ? (
                          <div
                            className="eliminar"
                            onClick={() => {
                              eliminar(
                                `geomed/noticias/${noticia.id_noticia}`,
                                { estado: false },
                                `geomed/buscador/${noticia.id_noticia}/${component}`
                              );
                            }}
                            title="Eliminar"
                          >
                            <IconButton className="icon-eliminar" />
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="flex-conoce-mas-opendata mt-2">
                  <div className="content-card-flex-column">
                    <span className="span-tarjetas-noticias-categoria">
                      {noticia.categoria}
                    </span>
                    <span className="span-bold">
                      {convertirFechaISOaDDMMAAAA(noticia.fecha_registro)}
                    </span>
                  </div>
                  <div className="flex-container_conoceMas">
                    <Button
                      className="btn-conoce-mas-noticia"
                      onClick={() => {
                        redireccionCard(noticia.vinculo);
                        guardarUbicacion("7", "2", noticia.id_noticia);
                      }}
                    >
                      CONOCE MÁS
                    </Button>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <>
            <div className="flex-msg_noResults">
              <h2>No se han encontrado resultados para tu búsqueda.</h2>
            </div>
          </>
        )}
        <AdminNoticia
          caractFiltro={filtros}
          idComponente={component}
          show={show}
          onHide={() => handleClose()}
          tituloModal={"Editar Noticia"}
          accion={"Editar"}
          objectEditarNoticia={objectEditar}
          buscar={buscar}
          handleLoad={handleLoad}
        />
      </div>
    );
  } else if (component === 0) {
    return (
      <div className="content-list-card-search-h">
        {data.length > 0
          ? data.map((buscador, index) => {
              return (
                <>
                  <div className="content-card-serach-h mt-5">
                    <div className="barra-card-search-h"></div>
                    <div className="conent-list-card-h">
                      <div className="flex-colunm">
                        <label class="lbl-titulo-search mt-2">
                          {
                            componentes.filter(
                              (componente) =>
                                componente.id_componente ===
                                buscador.fk_id_componente
                            )[0]?.nombre_componente
                          }
                        </label>
                        <label className="lbl-descripcion-search-h mt-3">
                          {buscador.nombre}
                        </label>
                      </div>
                      <div>
                        <button
                          type="button"
                          class="btn-ira-tarjeta-destacados btn btn-primary"
                          onClick={() => {
                            const url = componentes.filter(
                              (componente) =>
                                componente.id_componente ===
                                buscador.fk_id_componente
                            )[0]?.url_componente;

                            navigate({
                              pathname: url,
                              search: `?id=${buscador.id_elemento}`,
                            });
                          }}
                        >
                          IR A
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              );
            })
          : ""}
      </div>
    );
  } else if (component === 12) {
    return (
      <div className="tamano-card-result" ref={refDivCard}>
        {data.length > 0 ? (
          data.map((grupo, index) => {
            debugger;
            return (
              <div
                key={grupo.id_grupo}
                className="card-content-grupos color-fondo-card top-descricpion-result-busqueda hover-tajetas-aplicaciones"
              >
                <div className="conyten-img-card">
                  {grupo.permite_edicion || permissions.superAdmin ? (
                    <div className="content-opciones-card">
                      {grupo.permite_edicion || permissions.superAdmin ? (
                        <div
                          className="editar"
                          title="Editar"
                          onClick={() => {
                            handleShow();
                            setObjectEditar(grupo);
                          }}
                        >
                          <IconButton className="icon-editar" />
                        </div>
                      ) : (
                        ""
                      )}
                      {permissions.superAdmin && grupo.activo ? (
                        <div
                          className="eliminar"
                          onClick={() => {
                            eliminar(
                              `geomed/grupos/${grupo.id_grupo}`,
                              { estado: false },
                              `geomed/buscador/${grupo.id_grupo}/${component}`
                            );
                          }}
                          title="Eliminar"
                        >
                          <IconButton className="icon-eliminar" />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <span className="span-tarjetas-titulo-grupo">
                  {grupo.nombre}
                </span>
                <div className="padding-tarjetas-app">
                  <label
                    className="lbl-descripcion-app"
                    title={grupo.descripcion}
                  >
                    {grupo.descripcion}
                  </label>
                </div>
                {permissions.superAdmin ? (
                  <div className="container-button-vermas">
                    <button
                      className={`btn-geomedellin btn-register-admin btn btn-primary`}
                      onClick={() => {
                        redireccionCard(grupo.vinculo);
                      }}
                    >
                      Ver más
                    </button>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            );
          })
        ) : (
          <>
            <div className="flex-msg_noResults">
              <h2>No se han encontrado resultados para tu búsqueda.</h2>
            </div>
          </>
        )}
        <AdminGrupos
          caractFiltro={filtros}
          idComponente={component}
          show={show}
          onHide={() => handleClose()}
          tituloModal={"Editar Grupo"}
          accion={"Editar"}
          objectEditarApp={objectEditar}
          buscar2={buscar2}
          setShow={setShow}
          setObjectEditar={setObjectEditar}
          infoUser={infoUser}
          permissions={permissions}
        />
      </div>
    );
  }
}
